import { render } from "./RestaurantBlock.vue?vue&type=template&id=79a2a992&scoped=true"
import script from "./RestaurantBlock.vue?vue&type=script&lang=js"
export * from "./RestaurantBlock.vue?vue&type=script&lang=js"

import "./RestaurantBlock.vue?vue&type=style&index=0&id=79a2a992&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79a2a992"
/* hot reload */
if (module.hot) {
  script.__hmrId = "79a2a992"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79a2a992', script)) {
    api.reload('79a2a992', script)
  }
  
  module.hot.accept("./RestaurantBlock.vue?vue&type=template&id=79a2a992&scoped=true", () => {
    api.rerender('79a2a992', render)
  })

}

script.__file = "src/components/blocks/RestaurantBlock.vue"

export default script